// extracted by mini-css-extract-plugin
export default {"container":"TeamList_container__QjHsP","list":"TeamList_list__4u0qI"};